import { Animated, Platform } from "react-native";

if (Platform.OS === "web") {
  const timing = Animated.timing;
  const spring = Animated.spring;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Animated.timing = (
    value: Animated.AnimatedValue,
    config: Animated.TimingAnimationConfig,
  ): Animated.CompositeAnimation =>
    timing(value, { ...config, useNativeDriver: false });

  Animated.spring = (value, config) =>
    spring(value, {
      ...config,
      useNativeDriver: false,
    });
}
